import React from 'react';
import styled from 'styled-components';
import { Flex } from '../design-system';
/*
 source: https://dev.to/bravemaster619/simplest-way-to-embed-a-youtube-video-in-your-react-app-3bk2
*/
const VideoResponsive = styled(Flex)`
  overflow: hidden;
  padding-bottom: 56.25%;
  position: relative;
  justify-content: center;
  height: 0;
`;

interface YoutubeEmbedProps {
  embedId: string;
}

const YoutubeEmbed = ({ embedId }: YoutubeEmbedProps) => (
  <VideoResponsive className="video-responsive">
    <iframe
      width="853"
      height="480"
      src={`https://www.youtube.com/embed/${embedId}`}
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      title="Embedded youtube"
    />
  </VideoResponsive>
);

export default YoutubeEmbed;
